export default __webpack_public_path__ + "static/media/featSportBg.e3765318.png";